module.exports = __webpack_public_path__ + "img/storage-active.4cf8dd22.png";